var en_us = {
    values: {
        'Others Data': 'Others Data',
        'Region Performance': 'Region Performance'
    }
}

module.exports = en_us
